module.exports = __webpack_public_path__ + "static/media/bg.ef1763de.svg";